<template>
<div class="offers-full-width__offer-wrapper swiper-slide">
  <router-link :to="route" class="block">
    <article class="offers-full-width__offer">
      <div class="offers-full-width__image-wrapper">
        <responsive-image v-if="banner.image"
                          :media="banner.image"
                          :sizes="['hd', 'xlarge', 'large', 'medium']"
                          :alt="banner.title"
        />
      </div>
      <div class="offers-full-width__text-wrapper-wrapper static-container">
        <div v-if="banner.title || banner.description" class="offers-full-width__text-wrapper">
          <h3 v-if="banner.title" class="offers-full-width__offer-title">{{ banner.title }}</h3>
          <p v-if="banner.description" class="offers-full-width__offer-text">{{ banner.description }}</p>
        </div>
      </div>
    </article>
  </router-link>
</div>
</template>

<script>
import ResponsiveImage from '@/components/images/ResponsiveImage'

export default {
  props: {
    offer: {
      required: true,
      type: Object,
    },
  },

  components: {
    ResponsiveImage,
  },

  computed: {
    banner() {
      return this.offer.banners.desktop
    },

    article() {
      return this.offer.article
    },

    route() {
      if (!this.article || !this.article.title) {
        return '#'
      }

      return {
        name: 'offer-page',
        params: {
          shortId: this.offer.short_id,
          slug: this.offer.slug,
        }
      }
    },
  },
}
</script>
